import { useEffect } from 'react';

/**
 * Custom hook to dynamically set the favicon
 * @param {string} faviconUrl - The URL of the favicon to set
 */
const useFavicon = (faviconUrl) => {
  useEffect(() => {
    if (!faviconUrl) return;

    // Find existing favicon link elements
    let link = document.querySelector("link[rel*='icon']");

    if (!link) {
      // Create a new link element if one doesn't exist
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    // Update the href to the new favicon URL
    link.href = faviconUrl;

    // Also update other possible icon types for better browser compatibility
    const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (appleTouchIcon) {
      appleTouchIcon.href = faviconUrl;
    }

    // Update shortcut icon if it exists
    const shortcutIcon = document.querySelector("link[rel='shortcut icon']");
    if (shortcutIcon) {
      shortcutIcon.href = faviconUrl;
    }
  }, [faviconUrl]);
};

export default useFavicon;
